export const EVENT_CATEGORIES = {
	AUTH: 'auth',
	REPLICATION: 'replication',
	SALES: 'sales',
	SYSTEM: 'system',
	CART: 'cart',
} as const;

type CartActions = 'update' | 'add';

export const EVENTS = {
	AUTH: {
		USER_LOGIN: `${EVENT_CATEGORIES.AUTH}:user_logged_in`,
		ACCOUNT_DISABLED: `${EVENT_CATEGORIES.AUTH}:account_disabled`,
		PIN_CODE_SETUP: `${EVENT_CATEGORIES.AUTH}:pin_code_setup_initiated`,
	},
	REPLICATION: {
		CHANGE: (dbName: string) => `${EVENT_CATEGORIES.REPLICATION}:change:${dbName}`,
		completed: (dbName: string) => `${EVENT_CATEGORIES.REPLICATION}:completed:${dbName}`,
		FAILED: (dbName: string) => `${EVENT_CATEGORIES.REPLICATION}:failed:${dbName}`,
		STARTED: (dbName: string) => `${EVENT_CATEGORIES.REPLICATION}:started:${dbName}`,
	},
	SALES: {
		FAILED: `${EVENT_CATEGORIES.SALES}:failed`,
		STARTED: 'sales:started',
		CREATED: `${EVENT_CATEGORIES.SALES}:created`,
		NEXT_SALE_CLICKED: `${EVENT_CATEGORIES.SALES}:next_sale_clicked`,
		NEXT_SALE_FAILED: `${EVENT_CATEGORIES.SALES}:next_sale_failed`,
		PRINT_SUCCESS: `${EVENT_CATEGORIES.SALES}:print_success`,
		PRINT_FAILED: `${EVENT_CATEGORIES.SALES}:print_failed`,
	},
	CART: {
		INTENT: (action: CartActions) => `${EVENT_CATEGORIES.CART}:${action}:intent`,
		SUCCESS: (action: CartActions) => `${EVENT_CATEGORIES.CART}:${action}:success`,
		FAILED: (action: CartActions) => `${EVENT_CATEGORIES.CART}:${action}:failed`,
	},
	SYSTEM: {
		ERROR_BOUNDARY_TRIGGERED: `${EVENT_CATEGORIES.SYSTEM}:error_boundary_triggered`,
	},
} as const;
